/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Obligations_TitleInputs */

const es_tyc_obligations_title = /** @type {(inputs: Tyc_Obligations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Obligaciones del Usuario`)
};

const en_tyc_obligations_title = /** @type {(inputs: Tyc_Obligations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. User Obligations`)
};

/**
* | output |
* | --- |
* | "4. User Obligations" |
*
* @param {Tyc_Obligations_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_obligations_title = /** @type {((inputs?: Tyc_Obligations_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Obligations_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_obligations_title(inputs)
	return en_tyc_obligations_title(inputs)
});
export { tyc_obligations_title as "tyc.obligations.title" }